module.exports = __webpack_public_path__ + "img/1476227553.ddc4c349.jpg";